import * as React from "react";
const SvgEventAvailable = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.53 11.06 15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94ZM21 3h-3V1h-2v2H8V1H6v2H3v18h18V3Zm-2 16H5V8h14v11Z",
  fill: "currentColor"
}));
export default SvgEventAvailable;